<template>
  <div class="audio-list-box" @click="hide">
    <div class="list" @click.stop>
      <div class="title">音频目录({{ list.length }}首)</div>
      <div class="list-box">
        <div
          class="item"
          v-for="(item, i) in list"
          :key="item.listeningResourceId"
          @click="onSelect(item)"
        >
          <span class="ellipsis" :class="{ active: index === i }">
            {{ item.listeningResourceName }}
          </span>
          <span class="active-icon">
            <img
              style="vertical-align: super;"
              v-if="index === i"
              src="../assets/img/play-active.png"
              alt=""
            />
          </span>
        </div>
      </div>
      <div class="close">
        <button @click="hide">关闭</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'audioList',
  data() {
    return {
      list: [],
      index: 0,
    };
  },
  mounted() {
    this.list = this.$parent.fileUrlArr;
    this.index = this.$parent.currAudioIndex;
  },
  methods: {
    hide() {
      this.$emit('hide');
    },
    onSelect(item) {
      this.$emit('hide', { listeningResourceId: item.listeningResourceId });
    },
  },
};
</script>
<style lang="less" scoped>
.audio-list-box {
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100%;
  // background:rgba(0,0,0,0.5);
  z-index: 2;
  animation: timing 0.1s 0.2s linear forwards;
}
@keyframes timing {
  0% {
    background: transparent;
  }
  100% {
    background: rgba(0, 0, 0, 0.5);
  }
}
.list {
  width: 100%;
  height: calc(100% - 89px);
  background: #fff;
  margin-top: 89px;
  animation: top 0.2s linear;
}
@keyframes top {
  0% {
    margin-top: 100%;
  }
  100% {
    margin-top: 89px;
  }
}
.title {
  height: 62px;
  font-size: 16px;
  color: #3b3e42;
  font-weight: 500;
  line-height: 62px;
  padding-left: 22px;
  border-bottom: 1px solid #f9f9f9;
}
.list-box {
  height: calc(100% - 143px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  font-size: 14px;
  margin: 0 20px;
  border-bottom: 1px solid #f9f9f9;
}
.ellipsis {
  display: inline-block;
  width: 318px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
  &.active {
    color: #0a93fc;
  }
}
.active-icon {
  display: inline-block;
  width: 12px;
  height: 12px;
}
.close {
  // position: absolute;
  // left: 0;
  // bottom: 0;
  width: 100%;
  height: 79px;
  font-size: 14px;
  text-align: center;
  color: #3b3e42;
  line-height: 20px;
  padding-top: 5px;
  border-top: 1px solid #f9f9f9;
  background: #fff;
  button {
    background: none;
    border: none;
    outline: none;
    font-size: 14px;
    padding: 10px 20px;
  }
}
</style>
